import { type ContextSource } from '~/components/v2/types/contextSources';

export type WorkspaceAgentGuidedVariantBrandColor = {
  hex: string;
  id: string;
  label: string;
};

export type WorkspaceAgentGuidedVariantBrandKit = {
  colors: WorkspaceAgentGuidedVariantBrandColor[];
  id: string;
  name: string;
};

const BRAND_COLOR_PATTERN = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/** Brand kit colors may be 3-digit. The canvas and the prompt always use 6-digit hex. */
const toGuidedVariantBrandHex = (value: string): string | null => {
  const match = BRAND_COLOR_PATTERN.exec(value.trim());

  if (!match) {
    return null;
  }

  const digits = match[1].replace(/^([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/, '$1$1$2$2$3$3');

  return `#${digits.toUpperCase()}`;
};

export const getWorkspaceAgentGuidedVariantBrandKit = (
  source: ContextSource,
): WorkspaceAgentGuidedVariantBrandKit | null => {
  const colors = source.fields
    .filter((field) => field.valueType === 'color')
    .flatMap((field) =>
      (field.values ?? []).flatMap((value) => {
        if (typeof value.value !== 'string') {
          return [];
        }

        const hex = toGuidedVariantBrandHex(value.value);

        if (!hex) {
          return [];
        }

        return [
          {
            hex,
            id: value.id,
            label: value.label?.trim() || field.name,
          },
        ];
      }),
    );

  if (colors.length === 0) {
    return null;
  }

  return { colors, id: source.id, name: source.name };
};
